import React from 'react'
import { useTranslation } from 'i18n'
import {
  Container,
  Title,
  NewTag,
  Description,
  Image,
  Button,
  ImageContainer
} from './RunningRecordsBanner.styles'
import { Cdn } from 'utils/assets'
import type { UserState } from 'utils/hooks/use-userInfo'
import { trackRunningRecordsBannerClicked } from 'utils/analytics/analytics'

export const LEARN_MORE_URL = '/biblioteca/running-records'
export const ADMIN_REPORT_URL = '/biblioteca/admin/relatorio-running-records'

const RunningRecordsBanner = ({ user }: { user: UserState }) => {
  const { t } = useTranslation()

  const isTeacher = Object.keys(user.teacher || {}).length > 0

  if (!user.canAccessRunningRecords || !isTeacher) {
    return null
  }

  const redirectUrl =
    user?.featureToggles?.storyTree || user?.featureToggles?.runningRecords
      ? ADMIN_REPORT_URL
      : LEARN_MORE_URL

  const handleClick = () => {
    trackRunningRecordsBannerClicked()
    window.open(redirectUrl, '_self')
  }

  return (
    <Container onClick={handleClick}>
      <NewTag size={5}>{t('Novidade!')}</NewTag>
      <Title size={2}>{t('Running Records')}</Title>

      <ImageContainer>
        <Image
          alt={t('Running Records Banner')}
          mobileImageUrl={Cdn.getImageUrl(
            'running-records/running-records-mobile.jpg'
          )}
          tabletImageUrl={Cdn.getImageUrl(
            'running-records/running-records-tablet.jpg'
          )}
          desktopImageUrl={Cdn.getImageUrl(
            'running-records/running-records-desktop.jpeg'
          )}
          width="100%"
          height="100%"
        />
      </ImageContainer>

      <Description>
        {t(
          'Personalize a prática de leitura de seus alunos ao aplicar Running Records usando a Árvore!'
        )}
      </Description>
      <Button
        theme={{ type: 'primaryLivros', size: 'large' }}
        size="medium"
        text={t('Aplicar Running Records')}
      />
    </Container>
  )
}

export default RunningRecordsBanner
